import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { API_URL } from '../config/api'
import './Projects.css'

function Projects() {
  const [projects, setProjects] = useState([])
  const [loading, setLoading] = useState(true)
  const [loadedImages, setLoadedImages] = useState({})

  const handleImageLoad = (id) => {
    setLoadedImages((prev) => ({ ...prev, [id]: true }))
  }

  // Optimized image URL resolver using Strapi formats (defaults to medium for grid view)
  const getImageUrl = (image, preferredSize = 'medium') => {
    if (!image) return null
    const attrs = Array.isArray(image.data) ? image.data[0]?.attributes : image.data?.attributes
    if (!attrs) return image.url || null

    const formats = attrs.formats
    if (formats) {
      if (preferredSize === 'small' && formats.small?.url) return formats.small.url
      if (preferredSize === 'medium' && formats.medium?.url) return formats.medium.url
      if (preferredSize === 'large' && formats.large?.url) return formats.large.url
    }
    return attrs.url || image.url
  }

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        // Reduced payload size by requesting only necessary fields & image formats
        const response = await fetch(
          `${API_URL}/api/projects?populate[image][fields][0]=url&populate[image][fields][1]=formats&fields[0]=title&fields[1]=date`
        )
        const data = await response.json()
        const projects = (data.data || []).map(item => ({
          id: item.id,
          ...item.attributes
        }))
        setProjects(projects)
      } catch (error) {
        console.error('Error fetching projects:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchProjects()
  }, [])

  return (
    <div className="projects">
      <h1>Onze Projecten</h1>
      <p className="subtitle">Showcase van ons beste carwrap werk</p>

      {loading ? (
        <div className="loading">Projecten worden geladen...</div>
      ) : projects.length === 0 ? (
        <div className="no-projects">
          <p>Nog geen projecten beschikbaar. Kom binnenkort terug!</p>
        </div>
      ) : (
        <div className="projects-grid">
          {projects.map((project, index) => (
            <Link key={project.id} to={`/projects/${project.id}`} className="project-card-link">
              <div className="project-card">
                <div className="image-wrapper">
                  {project.image && getImageUrl(project.image, 'medium') && (
                    <img
                      src={`${API_URL}${getImageUrl(project.image, 'medium')}`}
                      alt={project.title}
                      className="project-image"
                      loading={index < 4 ? 'eager' : 'lazy'}
                      decoding="async"
                      onLoad={() => handleImageLoad(project.id)}
                    />
                  )}
                  {loadedImages[project.id] && (
                    <span className="mobile-ribbon">Bekijk project ➔</span>
                  )}
                </div>
                <div className="project-info">
                  <h3>{project.title}</h3>
                  {project.date && (
                    <p className="project-date">{new Date(project.date).toLocaleDateString()}</p>
                  )}
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}

export default Projects